// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"Collapse_collapsed__1AqJn","show":"Collapse_show__2zoCW","collapsing":"Collapse_collapsing__2--Bx"};